export default __webpack_public_path__ + "static/media/your_logo_here.e3c54a9b.jpg";